import styles from './styles.module.scss';
import {useAppData} from "../../context/Contexts";

const StatusBar: React.FC = () => {
    const {currentAppData, setCurrentAppData} = useAppData();

    return (
        <section className={`${styles.status__bar}`}>
            <ul>
                <li className={currentAppData.step === 1 ? `${styles.active}` : ``}><span>1</span> Vehicle</li>
                {
                    currentAppData?.product && currentAppData?.product?.options.length > 0
                    && currentAppData?.product?.variants.edges.length > 1
                    && currentAppData?.product?.options.map((option, index) => {
                        return <li key={`option-${index}`} className={currentAppData.step === index + 2 ? `${styles.active}` : ``}><span>{index + 2}</span> {option.name}</li>
                    })
                }
            </ul>
        </section>
    );
};

export default StatusBar;